<template>
  <b-modal
    v-model="showModal"
    ref="modal"
    centered
    size="lg"
    class="alert-modal"
    footer-class="pt-0 border-0"
  >
    <template #modal-header>
      <div class="d-flex justify-content-center w-100 align-items-center">
        <div class="modal-title">ปรับส่วนลด</div>
      </div>
    </template>
    <div class="px-2 d-flex align-items-center">
      <InputText
        v-model="discount.custom_header_discount"
        placeholder="ปรับส่วนลด"
        type="number"
        class="flex-grow-1"
        :textFloat="discount.name"
        isRequired
        :isValidate="$v.discount.custom_header_discount.$error"
        :v="$v.discount.custom_header_discount"
      ></InputText>
      <p class="ml-2">บาท</p>
    </div>
    <template #modal-footer="{ hide }">
      <div class="d-flex justify-content-between w-100 my-0 align-items-center">
        <div class="text-link" @click="calDiscont()">กลับสู่ค่าตั้งต้น</div>
        <div class="d-flex">
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover btn-width mr-1"
            @click="save()"
          >
            ยืนยัน
          </b-button>
          <b-button
            variant="close"
            class="btn-modal btn-hover btn-width ml-1"
            @click="hide()"
          >
            ยกเลิก
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { required, minValue } from "vuelidate/lib/validators";
export default {
  components: { required },
  validations() {
    return {
      discount: {
        custom_header_discount: {
          required,
          minValue: minValue(1),
        },
      },
    };
  },
  data() {
    return {
      rawPrice: null,
      showModal: false,
      discount: {
        custom_header_discount: 0,
        name: "",
      },
    };
  },

  methods: {
    async show(discount, totalPrice) {
      this.discount = discount;
      console.log(this.discount.custom_header_discount);
      this.$set(
        this.discount,
        "custom_header_discount",
        this.discount.custom_header_discount
          ? this.discount.custom_header_discount
          : this.discount.promotion_value
      );
      this.rawPrice = totalPrice;
      this.showModal = true;
    },
    save() {
      this.$v.discount.$touch();

      if (this.$v.$error) {
        return;
      }
      this.$emit("success", this.discount);
      this.$v.$reset();
      this.showModal = false;
    },
    calDiscont() {
      this.discount.custom_header_discount = this.discount.promotion_value;
      this.$forceUpdate();
    },
  },
};
</script>
